import React, { Component } from 'react'
import ReactHtmlParser from 'react-html-parser'
import { Link } from 'gatsby'

import Attribute from '@/components/Attribute'
import Image from '@/components/Image'

export default class SubProject extends Component {
  render() {
    const project = this.props.project.frontmatter
    const details = project.details
    return (
      <article className='SubProject'>
        <div className='cols cols--15'>
          <div className='col-50'>
            <div className='SubProject__details'>
              <Link
                className='SubProject__title mb-40 block'
                to={this.props.project.fields.slug}>
                <h1
                  className='mb-32 SubProject__name title-3'
                  data-aos='fade-right'>
                  <span>{project.title}</span>
                </h1>
              </Link>
              <div className='mb-40' data-aos='fade-right' data-aos-delay='100'>
                {ReactHtmlParser(this.props.content)}
              </div>
              <div
                className='attributes'
                data-aos-delay='200'
                data-aos='fade-right'>
                {details &&
                  Object.keys(details).map((key, i) => (
                    <Attribute
                      key={i}
                      name={key}
                      value={details[key]}
                      light={true}></Attribute>
                  ))}
              </div>
            </div>
          </div>
          <div className='col-50'>
            {project.video?.active ? (
              <video
                src={project.video.url}
                className='featured-video'
                controls
                muted
                loop
                autoPlay></video>
            ) : (
              project.thumbnail && (
                <Image
                  className='project__image mb-32'
                  author={project.thumbnail.author}
                  aos='fade-left'
                  delay='300'
                  image={project.thumbnail.image}
                />
              )
            )}
          </div>
        </div>
      </article>
    )
  }
}
